import Gtin from './Gtin';

export default Gtin;